import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>; // Ou un spinner de chargement
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return children ? children : <Outlet />;
};

export default PrivateRoute;
